import React from 'react';
import TenantMobileLayout from './TenantMobileLayout';
import FBCostPage from '../../pages/FBCostPage';

const TenantMobileFBCost = ({ onBack }) => {
  return (
    <TenantMobileLayout title="F&B Cost" onBack={onBack}>
      <div className="mobile-content-wrapper">
        <FBCostPage />
      </div>
    </TenantMobileLayout>
  );
};

export default TenantMobileFBCost;
